<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="trail" :label="$t(title_trails)" icon="fas fa-sign" />

            <q-tab-pane name="trail" class="q-px-md q-pb-xl q-mt-md">
                <div>
                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-10">
                            <p class="q-title">{{ title }}</p>
                            <p class="q-body-1 text-weight-light">{{ description }}</p>
                        </div>

                        <div class="col-xs-12 col-sm-2">
                            <q-btn :label="$t('back')" color="primary" icon="fas fa-chevron-left" class="full-width" @click="$router.push({ name: 'trails' })" />
                        </div>

                        <div class="col-xs-12 col-sm-3">
                            <filter-courses />
                        </div>

                        <div class="col-xs-12 col-sm-9">
                            <div class="row gutter-md">
                                <div class="col-xs-12 col-sm-12" v-for="(course, index) in filteredCourses" :key="index">
                                    <card-desktop :course="course" v-if="$q.platform.is.desktop" :key="course.id" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" />
                                    <card-mobile :course="course" v-if="$q.platform.is.mobile" :key="course.id" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" />
                                </div>
                                <div class="col-xs-12 col-sm-12" v-if="filteredCourses.length == 0">
                                    <q-card>
                                        <q-card-title>
                                            {{ $t('no_course_found') }}
                                        </q-card-title>
                                        <q-card-separator />
                                        <q-card-main v-if="this.search || this.selected_areas.length > 0 || this.favorite != 'all' || this.progress != 'all' || this.selected_groups.length > 0">
                                            {{ $t('no_courses_found_with_this_filter') }}
                                        </q-card-main>
                                        <q-card-main v-else>
                                            {{ $t('there_are_no_courses_avaliable_at_the_moment') }}
                                        </q-card-main>
                                    </q-card>
                                </div>
                            </div>
                        </div>
                    </div>

                    <modal-stars :show="show_modal" :course="course" @hideModal="hideModal" />
                </div>
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Filter from 'components/courses/Filter'
import CardDesktop from 'components/courses/CardDesktop'
import CardMobile from 'components/courses/CardMobile'
import ModalStars from 'components/courses/ModalStars'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "trails", "courses"] },

    data() {
        return {
            title: '',
            description: '',
            courses: [],
            course: [],
            show_modal: false,
            tab: 'trail'
        }
    },

    components: {
        'filter-courses': Filter,
        'card-desktop': CardDesktop,
        'card-mobile': CardMobile,
        'modal-stars': ModalStars
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            search: 'courses/search',
            progress: 'courses/progress',
            favorite: 'courses/favorite',
            selected_areas: 'courses/selected_areas',
            selected_groups: 'courses/selected_groups',
            clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        title_trails(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_trails == '' ? 'trails' : obj.title_trails
				}
			}
        },

        filteredCourses() {
            let filtered = []
            filtered = Object.assign(this.courses, [])

            if (this.search) {
                filtered = filtered.filter((course) => {
                    return course.title.toUpperCase().includes(this.search.toUpperCase())
                })
            }

            if (this.selected_areas.length > 0) {
                filtered = filtered.filter((course) => {
                    let result = this.selected_areas.filter(x => course.areas.includes(x))
                    return result.length > 0 ? true : false
                })
            }

            if (this.selected_groups.length > 0) {
                filtered = filtered.filter((course) => {
                    if (course.groups) {
                        let result = this.selected_groups.filter(x => course.groups.includes(x))
                        return result.length > 0 ? true : false
                    }
                    return false
                })
            }

            if (this.progress != 'all') {
                filtered = filtered.filter((course) => {
                    if (this.progress == 'in-progress') {
                        return course.user_progress > 0 && course.user_progress <  100 ? true : false
                    }
                    else if (this.progress == 'to-do') {
                        return course.user_progress == 0 ? true : false
                    }
                    else if (this.progress == 'finished') {
                        return course.user_progress == 100 ? true : false
                    }
                })
            }

            if (this.favorite != 'all') {
                filtered = filtered.filter((course) => {
                    return course.favorited
                })
            }

            return filtered
        }
    },

    methods: {
        fetchAll() {
            this.$q.loading.show()

            this.$axios.all([this.fetchLists(), this.fetchCourses()])
            .then(this.$axios.spread((lists, courses) => {
                this.$store.dispatch('site_lists/SET_LISTS', [lists.data])

                this.title = courses.data.title
                this.description = courses.data.description

                courses.data.trail_group_trainings.map((courses) => {
                    let course = courses.group_training
                    let image_small = ''
                    let image_thumb = ''

                    let obj = course.group_training_images.find((obj) => { return obj.name === 'thumbnail' })
                    if (obj) image_thumb = obj.image_url

                    obj = course.group_training_images.find((obj) => { return obj.name === 'small' })
                    if (obj) image_small = obj.image_url

                    this.courses.push({
                        id: course.id,
                        image_thumb: image_thumb,
                        image_small: image_small,
                        areas: course.areas,
                        group_training_user_result_status: course.group_training_user_result_status,
                        group_training_user_result_percent: course.group_training_user_result_percent,
                        liked: course.liked,
                        likes: course.likes ? course.likes : "0",
                        qty_modules: course.qty_modules ? course.qty_modules : "0",
                        qty_tests: course.qty_tests ? course.qty_tests : "0",
                        stars: course.avg_stars ? parseInt(course.avg_stars) : "0",
                        stars_rating: course.avg_stars,
                        starred: course.starred,
                        workload: course.workload,
                        tags: course.tags,
                        title: course.title,
                        description: course.description,
                        user_groups: course.user_groups,
                        group_training_type: course.group_training_type,
                        score: course.score ? course.score : "0",
                        qty_materials: course.qty_materials ? course.qty_materials : "0",
                        user_progress: parseInt(course.user_progress),
                        user_progress_string: course.user_progress_string ? course.user_progress_string : "0",
                        liked: course.liked,
                        favorited: course.favorited,
                        is_blocked: courses.is_blocked
                    })
                })

                this.$q.loading.hide()
            }))
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)

                this.$q.notify({
                    message: this.$t('trail_not_found'),
                    type: 'negative',
                    icon: 'fas fa-ban'
                })

                if (this.$route.name != 'admin_overview') {
                    let obj_redirect = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                    if (obj_redirect) {
                        if (obj_redirect.home_route) this.$router.replace({ name: obj_redirect.home_route })
                        else {
                            this.$router.replace({ name: 'courses' })
                        }
                    }
                    else {
                        this.$router.replace({ name: 'courses' })
                    }
                }
            })
        },

        fetchLists() {
            return this.$axios.get('/accounts/get_site_registration_lists/', this.getHeader)
        },

        fetchCourses() {
            return this.$axios.get(`/etraining_trails/trails/${this.$route.params.id}/`, this.getHeader)
        },

        clickLike(id) {
            let obj = this.courses.find((obj) => { return obj.id === id })

            if (obj) {
                if (obj.liked) obj.likes--
                else if (!obj.liked) obj.likes++

                obj.liked = !obj.liked
            }

            let fd = new FormData()

            this.$axios.post(`/etraining_courses/group_training/${id}/like_group_training/`, fd, this.getHeader)
            .then(response => {
                obj.likes = response.data.likes
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        clickFavorite(id) {
            let obj = this.courses.find((obj) => { return obj.id === id })

            if (obj) {
                obj.favorited = !obj.favorited
            }

            let fd = new FormData()

            this.$axios.post(`/etraining_courses/group_training/${id}/set_group_training_user_favorite/`, fd, this.getHeader)
            .then(response => {
                obj.favorited = response.data.favorited
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        clickStars(id) {
            let obj = this.courses.find((obj) => { return obj.id === id })

            if (obj) {
                this.course = obj
                this.show_modal = true
            }
        },

        hideModal(type) {
            if (type == 'commented') {
                this.course.starred = true
            }
            this.show_modal = false
        }
    },

    watch: {
        reload_content: function() {
            this.fetchAll()
        }
    },

    created() {
        this.fetchAll()
    }
}
</script>

<style lang="stylus" scoped>
p
    margin 0 0 10px

.training-thumb
    width 90%
    height auto
    border-radius 10px
</style>
